const selectLogo = (logoIndex) => {
  const allGifLogos = document.querySelectorAll(".demo-logo-container");
  allGifLogos.forEach((logo) => {
    const currentLogoIndex = logo.dataset.index;
    if (currentLogoIndex === logoIndex) {
      logo.classList.add("demo-gif-selected");
    } else {
      logo.classList.remove("demo-gif-selected");
    }
  });

  const allGifContainers = document.querySelectorAll(".demo-gif-container");
  allGifContainers.forEach((gif) => {
    const currentGifIndex = gif.dataset.index;
    if (currentGifIndex === logoIndex) {
      gif.classList.remove("demo-gif-container-hidden");
    } else {
      gif.classList.add("demo-gif-container-hidden");
    }
  });
};

document.addEventListener('DOMContentLoaded', e => {
  const allGifLogos = document.querySelectorAll(".demo-logo-container");
  allGifLogos.forEach((logo) => {
    logo.addEventListener("click", (e) => {
      selectLogo(logo.dataset.index);
    });
  });
});
